import React from "react";
import styled from "styled-components";
import { FaAtom } from "react-icons/fa";
import { useDesktopSiteDetection } from "../../../hooks/mobile_desktop_mode";



const SymposiumTheme = () => {
  const isDesktopSiteOnMobile = useDesktopSiteDetection()

  const themes = [
    "Advanced Energy Materials",
    "Advanced Functional Materials",
    "Advanced Photonic Materials",
    "Advanced Electronic Materials",
    "Advanced Structural Materials",
    "Advanced Biomaterials for Healthcare",
    "Advanced Nanoscience and Nanotechnology",
    "Advanced Geosciences and Technology (Mining, Oil and Gas, Minerals extraction)", 
    "Advanced Computational, Artificial Intelligence and Machine Learning in Materials",
    "Advanced Materials for Water and Environmental Remediation (Recycling and Green Technology)"
  ];

  return (
    <Section>
        <HeaderContainer>
            <HeaderDivider>
                <div className="line"></div>
                <div className="diamond">
                <IconWrapper>
                    <FaAtom />
                </IconWrapper>
                </div>
                <div className="line"></div>
            </HeaderDivider>
            <Title className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>Symposium Themes</Title>
        </HeaderContainer>
      <ThemeGrid>
        {themes.map((theme, index) => (
          <ThemeCard key={index}>
            <ThemeText className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>{theme}</ThemeText>
          </ThemeCard>
        ))}
      </ThemeGrid>
    </Section>
  );
};

const Section = styled.section`
  text-align: center;
  padding: 60px 20px;
  background-color: white;
`;

const IconWrapper = styled.div`
  font-size: 36px;
  color: #3b82f6;
`;


const ThemeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  
  @media screen and (max-width: 480px) and (min-resolution: 1dppx) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 10px;
  }
`;

const ThemeCard = styled.div`
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

`;

const ThemeText = styled.div`
  font-size: 18px;
  color:  #CA9D3B;
  font-weight: 500;

  &.desktop-site-mode {
    font-size: 0.7rem;
  }
`;
const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const HeaderDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  .line {
    height: 1px;
    background-color: #d1d5db;
    width: 3rem;
  }

  .diamond {
    margin: 0 1rem;
  }
`;

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #1f2937;

  &.desktop-site-mode {
    font-size: 0.7rem;
  }
`;
export default SymposiumTheme;
